"use client";

import React, { useEffect, useState } from "react";
import CommonSchema from "@/components/common/CommonSchema";
import { Banner } from "../common/Banner";
import { FadeInSection } from "../common/FadeInSection";
import { NotebookText } from "lucide-react";
import { useAppSelector } from "@/store/hooks";
import { cleanHeaderTags, createLookupObject } from "@/_helper/helper";

export default function TermsConditionsClient({ cmsData, initialBanner }: { cmsData: any; initialBanner?: any }) {
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const banner: any =
    initialBanner ||
    BannerList?.find(
      (banner: any) => banner?.BannerType === "terms-conditions",
    ) || {};

  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, any>>({});

  useEffect(() => {
    if (cmsData && cmsData.length > 0) {
      setLookUpCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  return (
    <div className="min-h-screen bg-[#fdfcfa]">
      <CommonSchema />
      <Banner
        title={banner?.BannerTitle || "Terms & Conditions"}
        description={banner?.Description}
        bgImage={banner?.BannerImage}
        // icon={<NotebookText className="w-12 h-12 text-[#d4af37]" />}
      />

      <section className="py-10 md:py-15 blog-content">
        <div className="max-w-7xl mx-auto px-6">
          <FadeInSection>
            {lookUpCMSData?.["Terms And Conditions - Content"] ? (
              <div
                className="space-y-10"
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    lookUpCMSData?.["Terms And Conditions - Content"]?.Template,
                  ),
                }}
              />
            ) : (
              <div className="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-gray-100 dark:bg-gray-800 rounded-lg shadow-md">
                <svg
                  className="w-12 h-12 dark:text-gray-400 text-gray-700"
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  height="200px"
                  width="200px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="File_Off">
                    <g>
                      <path d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"></path>
                      <path d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"></path>
                    </g>
                  </g>
                </svg>
                <h3 className="text-xl font-medium mt-4 text-gray-700 dark:text-gray-200">
                  No data found
                </h3>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                  The data you are looking for is not available.
                </p>
              </div>
            )}
            {/* <div className="space-y-10">
              <h2>Terms &amp; Conditions</h2>
              <div>
                <h3>Child Policy -</h3>
                <p>
                  One Child Complimentary(Per Room) Upto 05 Yrs. on Sharing Same
                  Bed. (If Guest Requires Extra Bed 1000 Rs. will be charged for
                  extra bed only Inclusive of Taxes).
                </p>
                <p>Extra Person Above 05 Years Would be charged As an Adult.</p>
              </div>

              <div>
                <h3>Please note :-</h3>
                <p>
                  Buffet is subject to occupancy, meals will be served as A
                  la-carte on Plan. Above rates Are not applicable on Blackout
                  Date and Long Weekend.
                </p>
              </div>

              <div>
                <h3>Reservation Policy</h3>
                <ul>
                  <li>
                    Valid Government Photo Id with Address Required on Check-in
                    Time. For Foreign
                  </li>
                  <li>
                    Nationality Valid Passport &amp; Visa Required Upon Check
                    Time.
                  </li>
                  <li>All above rates are on Twin / Double occupancy basis.</li>
                  <li>
                    Check-in time will be 1400Hrs. and check-out is 1100Hrs.
                  </li>
                  <li>
                    All bookings will be confirmed with 100 % advance payment
                  </li>
                </ul>
              </div>
              <div>
                <h3>Deposit Policy</h3>
                <p>
                  All reservations must be guaranteed with a one night deposit
                  at the time of booking. A non-refundable balance full payment
                  will be charged 15 days prior to arrival.{" "}
                </p>
              </div>
              <div>
                <h3>Cancellation Policy</h3>
                <ul>
                  <li>
                    100% Retention in case of cancellation / Amendment done in
                    less than 15 days from the date of Check in.
                  </li>
                  <li>
                    75% of the price will be charged as a cancellation fee, if
                    booking cancelled within the 20 day period.
                  </li>
                  <li>
                    50% of the package price will be charged as a cancellation
                    fee, if booking cancelled within the 30 day period.{" "}
                  </li>
                  <li>NO refund will be made in case of No-Show. </li>
                </ul>
              </div>
              <div>
                <h3>
                  For Booking Confirmation Please Deposit Amount In Our bank
                  Details As Below:-
                </h3>
                <b className="font-medium">
                  Bank Details For Payment as below:-
                </b>

                <ul>
                  <li>
                    <i className="fa-regular fa-angles-right"></i>BENEFICIARY
                    NAME
                  </li>
                  <li>
                    SARASIRUHAM Resort (A Unit of Ekling Sarovar Resort Private
                    Limited){" "}
                  </li>
                  <li>BANK NAME</li>
                  <li>Icici Bank Ltd</li>
                  <li>BRANCH ADDRESS</li>
                  <li>Rajasthan College Of Agr.campus, Udaipur 313001</li>
                  <li>ACCOUNT NO.</li>
                  <li>693905601311 </li>
                  <li>IFSC CODE</li>
                  <li>ICIC0006939</li>
                </ul>
              </div>
              <div>
                <p>
                  <b>Note:-</b> PLEASE DO NOT DEPOSIT AMOUNT IN CASH.
                </p>
                <p>
                  <b>Note:-</b> IF YOU NEED GST INVOICE,PLEASE SHARE GST DETAIL
                  BEFORE GUEST C/IN .
                </p>
                <p>Rate could be changed anytime without any prior notice.</p>
              </div>
              <div>
                <h3>Experiences:</h3>
                <p>
                  Come experience the magic of love, Valour and hospitality of
                  Mewar with Sarasiruham Resort.
                </p>
                <p>
                  For reservations please contact the hotel reservations
                  department on telephone&nbsp;
                  <a href="tel:+917849902266">+91- 7849902266</a>&nbsp;or mail
                  to:&nbsp;
                  <a href="mailto:gm@sarasiruhamresort.com">
                    gm@sarasiruhamresort.com
                  </a>
                </p>
                <p>
                  For Further details please visit our website &nbsp;
                  <a href="https://www.sarasiruhamresort.com" target="_blank">
                    www.sarasiruhamresort.com
                  </a>
                </p>
              </div>
            </div> */}
          </FadeInSection>
        </div>
      </section>
    </div>
  );
}
